/*
 * Lemonade Training Oy copy rights all right reserved.
 * Result Event Contract (F028): one server-side structured log line per
 * successful log, edit, delete or restore of an athlete's result. Frozen
 * names; never a uid, record id, movement, value, date or note.
 */

import type { LegacyInputMode } from "./movementState";

export const RESULT_EVENTS = Object.freeze({
  logged: "result_logged",
  edited: "result_edited",
  /** Also a restore, told apart by `restored`. */
  deleted: "result_deleted",
} as const);

export type ResultEventName =
  (typeof RESULT_EVENTS)[keyof typeof RESULT_EVENTS];

/** What a client may send as `source`; anything else is rejected. */
export const RESULT_EVENT_SOURCES = Object.freeze(["mobile", "web"] as const);
export type ResultEventSource = (typeof RESULT_EVENT_SOURCES)[number];

/** `unknown` is what the server logs when the request carried no `source`. */
export const RESULT_EVENT_SOURCE_LABELS = Object.freeze([
  ...RESULT_EVENT_SOURCES,
  "unknown",
] as const);

export const RESULT_EVENT_INPUT_MODES = Object.freeze([
  "oneRepMax",
  "workingSet",
  "workoutTime",
  "unknown",
] as const satisfies readonly (LegacyInputMode | "unknown")[]);

/** A logged result dated more than this before the server clock is `backdated`. */
export const RESULT_EVENT_BACKDATED_AFTER_MS = 24 * 60 * 60 * 1000;

export const RESULT_EVENT_ALLOWED_PROPS = Object.freeze({
  result_logged: Object.freeze([
    "source",
    "inputMode",
    "measureType",
    "scoringType",
    "isNewPR",
    "hasNotes",
    "backdated",
  ] as const),
  result_edited: Object.freeze([
    "source",
    "inputMode",
    "measureType",
    "scoringType",
    "valueChanged",
    "dateChanged",
    "notesChanged",
    "noOp",
    "currentChanged",
  ] as const),
  result_deleted: Object.freeze([
    "source",
    "inputMode",
    "restored",
    "noOp",
    "currentChanged",
  ] as const),
} as const satisfies Record<ResultEventName, readonly string[]>);
